import React from "react";
import Button from "react-bulma-components/lib/components/button";
import Modal from "react-bulma-components/lib/components/modal";
import "../../styles/yourOrders.css";
import "../../styles/artworks.css";
import { Redirect } from "react-router-dom";
import FollowersList from "./followersList";
import { overFlowHidden, removeOverFlowHidden } from '../../helpers/reusable.js'
import ArtworkCard from "../cardHolders/artworksCardProfile";
import { inject, observer } from "mobx-react";
import ArtworkCard_ from "../cardHolders/artworksCard";
import {
    validateIfInputHasCharacters,
    validateIfInputHasSpaces,
    validateIfInputHasUpperCaseLetter,
    validateIfInputHasYourMasterpieces,
    validateInputLength
} from "../../../src/helpers/validationChecks";
import { DropdownToggle, UncontrolledDropdown } from "reactstrap";
import ShareMenu from "../../../src/helpers/shareTheUrl"

const uploadArtIcon = require('../../assets/upload_icon_png.png')
const uploadArtIconBig = require('../../assets/upload_icon_big.svg')
const goldenHandIcon = require('../../assets/Seller_terms.png')

const imagesPath = {
    unchecked: require('../../assets/unchecked.png'),
    checked: require('../../assets/checked.png')
}





@inject('userStore', 'navigatorStore', 'authStore', 'landingPageArtworksStore', 'artworksStore', 'artistDetails', 'followAndLikeStore')
@observer
export default class ArtistDetails extends React.Component {
    constructor(props) {
        super(props);
        // // console.log("Url With Name ", this.props.match.url);
        const Id = ArtistIdFromUrl(this.props.match.url);
        // // console.log("Artist ID", Id);
        this.state = {
            followedThisArtist: false,
            viewFollowersList: false,
            viewFollowingList: false,
            uploadArt: false,
            readInstructions: false,
            wantsToContinue: false,
            myOwnProfile: true,
            artworkClicked: false,
            buyingTab: "visible",
            sellingTab: "hidden",
            artistData: false,
            artistId: false,
            followersList: false,
            followingList: false,
            artist_profile_tags: [],
            uniqueContainerIdFollowers: "container_followers" + new Date().getTime() + Math.random(),
            uniqueContainerIdFollowing: "container_following" + new Date().getTime() + Math.random(),

        }
    }
    handleViewProfile() {
        this.setState({
            toProfile: true
        })
    }
    componentWillUnmount() {
        this.props.artworksStore.resetCollectionMyProfile()
        this.props.artistDetails.reset()

    }
    loadArtistData(id, hide, notAllDataRequired) {
        // var artistId;
        if (notAllDataRequired) this.props.artistDetails.reset();

        this.props.artistDetails.getArtistDetailsPublic(id, hide)

            .then((resp) => {
                // console.log("this is artist data", resp);
                // artistId: resp.data.data[0].id;
                if (!notAllDataRequired) {
                    this.setState({
                        artworkCount: resp.data.count,
                        artistData: resp.data.data,
                        followersCount: (resp.data.count) ? resp.data.data[0].user_profile.followers : resp.data.data.user_profile.followers,
                        following: (resp.data.count) ? resp.data.data[0].user_profile.following : resp.data.data.user_profile.following,
                        collectionCount: (resp.data.count) ? resp.data.data[0].user_profile.total_likes_given : resp.data.data.user_profile.total_likes_given,
                        followedThisArtist: (resp.data.count) ? resp.data.data[0].isfollowing : resp.data.data.user_profile.isfollowing,
                        artistId: (resp.data.count) ? resp.data.data[0].user_profile.id : resp.data.data.user_profile.id,
                        myOwnProfile: (id == localStorage.getItem("profile_id"))
                    }, function () {
                        // // console.log("this is artist data", this.state.artistData)
                        // var tags = [];
                        /* user tags logic */
                        if (this.state.artistData && this.state.artistData[0]) {
                            this.artistProfileTagsIdentifier(this.state.artistData[0])
                        }
                        else if (this.state.artistData) {
                            this.artistProfileTagsIdentifier(this.state.artistData)
                        }
                        // this.loadOtherData(this.state.artistId, hide)
                    }
                    )
                }
                else {
                    this.setState({

                        followersCount: (resp.data.count) ? resp.data.data[0].user_profile.followers : resp.data.data.user_profile.followers,
                        following: (resp.data.count) ? resp.data.data[0].user_profile.following : resp.data.data.user_profile.following,

                    }, function () {
                        // console.log("this is artist data", this.state.artistData)
                        // var tags = [];
                        /* user tags logic */
                        if (this.state.artistData && this.state.artistData[0]) {
                            this.artistProfileTagsIdentifier(this.state.artistData[0])
                        }
                        else if (this.state.artistData) {
                            this.artistProfileTagsIdentifier(this.state.artistData)
                        }
                        // this.loadOtherData(this.state.artistId, hide)
                    }
                    )
                }
            })
    }
    artistProfileTagsIdentifier(data) {
        var tags = [];
        if (data.user_profile.total_artworks_uploaded == 0 &&
            data.user_profile.total_likes_given == 0 &&
            data.user_profile.following == 0) {
            tags.push('NEW USER')
        }
        if (data.user_profile.total_artworks_uploaded == 0 &&
            data.user_profile.total_likes_given == 0 &&
            data.user_profile.following > 0) {
            tags.push('EXPLORER')
        }
        if (data.user_profile.total_artworks_uploaded > 0 &&
            data.user_profile.total_likes_given == 0 &&
            data.user_profile.following == 0) {
            tags.push('ARTIST')
        }
        if (data.user_profile.total_artworks_uploaded == 0 &&
            data.user_profile.total_likes_given > 0 &&
            data.user_profile.following == 0) {
            tags.push('ART LOVER')
        }
        if (data.user_profile.total_artworks_uploaded == 0 &&
            data.user_profile.total_likes_given > 0 &&
            data.user_profile.following > 0) {
            tags.push('ART LOVER')
            tags.push('EXPLORER')
        }
        if (data.user_profile.total_artworks_uploaded > 0 &&
            data.user_profile.total_likes_given > 0 &&
            data.user_profile.following == 0) {
            tags.push('ARTIST')
            tags.push('ART LOVER')
        }
        if (data.user_profile.total_artworks_uploaded > 0 &&
            data.user_profile.total_likes_given == 0 &&
            data.user_profile.following > 0) {
            tags.push('ARTIST')
            tags.push('EXPLORER')
        }
        if (data.user_profile.total_artworks_uploaded > 0 &&
            data.user_profile.total_likes_given > 0 &&
            data.user_profile.following > 0) {
            tags.push('ARTIST')
            tags.push('ART LOVER')
            tags.push('EXPLORER')
        }
        // console.log("[user tags]", tags)
        this.setState({
            shareUrl: false,
            artist_profile_tags: tags
        })
    }
    componentDidMount() {
        this.props.artistDetails.reset()
        // console.log("mounted profile     document.documentElement.clientWidth", this.props.match.params.id, document.documentElement.clientWidth)
        // var str = this.props.match.params.id;
        this.props.artistDetails.reset();

        this.setState({
            viewPortWidth:

                document.documentElement.clientWidth > 1300 ? 350 : 250
        });
        if (localStorage.hasOwnProperty("userData")
        ) {

            this.props.userStore.pulluser().then((result) => {
                // console.log("{this is pulled user}", result)
                result.data[0]

                // if (!result.data[0].interests) {
                //     // console.log("interests null")
                //     this.setState({
                //         onboardingOneIncomplete: true
                //     })
                // }
                // if (!result.data[0].preferences) {
                //     // console.log("preferences null")
                //     this.setState({
                //         onboardingTwoIncomplete: true
                //     })
                // }

                if (!result.data[0].display_name && !!result.data[0].old_display_name) {
                    if ((result.data[0].old_display_name) && !validateInputLength(result.data[0].old_display_name, 6, 30)) {
                        // this.props.navigatorStore.openErrorModal("username should contain 6-30 characters");
                        this.setState({
                            onboardingThreeIncomplete: true
                        })
                        return;
                    }
                    if ((result.data[0].old_display_name) && !validateIfInputHasSpaces(result.data[0].old_display_name, 6, 30)) {
                        // this.props.navigatorStore.openErrorModal("username can not contain spaces")
                        this.setState({
                            onboardingThreeIncomplete: true
                        })
                        return;
                    }
                    if ((result.data[0].old_display_name) && validateIfInputHasCharacters(result.data[0].old_display_name)) {
                        // this.props.navigatorStore.openErrorModal("username can not contain characters");
                        this.setState({
                            onboardingThreeIncomplete: true
                        })
                        return;
                    }
                    if ((result.data[0].old_display_name) && validateIfInputHasUpperCaseLetter(result.data[0].old_display_name)) {
                        // this.props.navigatorStore.openErrorModal("username can not contain an uppercase letter")
                        this.setState({
                            onboardingThreeIncomplete: true
                        })
                        return;
                    }
                    if ((result.data[0].old_display_name) && validateIfInputHasYourMasterpieces(result.data[0].old_display_name)) {
                        // this.props.navigatorStore.openErrorModal("username can not contain yourmasterpieces in it")
                        this.setState({
                            onboardingThreeIncomplete: true
                        })
                        return;
                    }
                    var formData = new FormData();
                    formData.append("display_name", this.state.formInputs.display_name)
                    // if (!!this.state.formInputs.display_name && (this.state.curr_display_name != this.state.formInputs.display_name))
                    this.props.userStore.validateDisplayName(formData)
                        .then((response) => {
                            // console.log(response)
                            if (response.error == "True") {
                                this.setState({
                                    onboardingThreeIncomplete: true,
                                    // formInputs: { ...this.state.formInputs, display_name: "" }
                                })
                                // this.props.navigatorStore.openErrorModal(response.data)
                                return;
                            }
                            else {
                                this.setState({
                                    onboardingThreeIncomplete: true
                                })
                                return;

                            }
                        })
                        .catch((err => {
                            this.setState({
                                onboardingThreeIncomplete: true,



                            })
                        }));
                }

                if (result.data[0].display_name) {
                    if ((result.data[0].display_name) && !validateInputLength(result.data[0].display_name, 6, 30)) {
                        // this.props.navigatorStore.openErrorModal("username should contain 6-30 characters");
                        this.setState({
                            onboardingThreeIncomplete: true
                        })
                        return;
                    }
                    if ((result.data[0].display_name) && !validateIfInputHasSpaces(result.data[0].display_name, 6, 30)) {
                        // this.props.navigatorStore.openErrorModal("username can not contain spaces")
                        this.setState({
                            onboardingThreeIncomplete: true
                        })
                        return;
                    }
                    if ((result.data[0].display_name) && validateIfInputHasCharacters(result.data[0].display_name)) {
                        // this.props.navigatorStore.openErrorModal("username can not contain characters");
                        this.setState({
                            onboardingThreeIncomplete: true
                        })
                        return;
                    }
                    if ((result.data[0].display_name) && validateIfInputHasUpperCaseLetter(result.data[0].display_name)) {
                        // this.props.navigatorStore.openErrorModal("username can not contain an uppercase letter")
                        this.setState({
                            onboardingThreeIncomplete: true
                        })
                        return;
                    }
                    if ((result.data[0].display_name) && validateIfInputHasYourMasterpieces(result.data[0].display_name)) {
                        // this.props.navigatorStore.openErrorModal("username can not contain yourmasterpieces in it")
                        this.setState({
                            onboardingThreeIncomplete: true
                        })
                        return;
                    }
                }
                if (!result.data[0].full_name ||
                    !result.data[0].country ||
                    //  !response.data.user_profile[0].full_name || 
                    //  !response.data.user_profile[0].user.email || 
                    //  !response.data.user_profile[0].display_name || 
                    !result.data[0].display_name ||
                    result.data[0].display_name.length >= 30 ||
                    !result.data[0].primary_email ||
                    !result.data[0].preferred_currency

                ) {
                    // console.log("profile null")
                    this.setState({
                        onboardingThreeIncomplete: true
                    })
                    return;
                    // this.state.makeOnboardingThreeIncomplete()
                }

            })
        }
        // (localStorage.hasOwnProperty("userData")) ?
        if (!!localStorage.getItem("username")) {
            this.props.artistDetails.getArtistDetailsPrivate(localStorage.getItem("username"))
                .then((resp) => {
                    // console.log("this is artist data", resp);
                    this.setState({
                        artistData: resp.data.data,
                        artworkCount: resp.data.count,
                        followersCount: (resp.data.count) ? resp.data.data[0].user_profile.followers : resp.data.data.user_profile.followers,
                        following: (resp.data.count) ? resp.data.data[0].user_profile.following : resp.data.data.user_profile.following,
                        collectionCount: (resp.data.count) ? resp.data.data[0].user_profile.total_likes_given : resp.data.data.user_profile.total_likes_given,
                        followedThisArtist: (resp.data.count) ? resp.data.data[0].isfollowing : resp.data.data.user_profile.isfollowing,
                        artistId: (resp.data.count) ? resp.data.data[0].user_profile.id : resp.data.data.user_profile.id,
                        artistId: localStorage.getItem("profile_id")
                    }, function () {

                        // console.log(resp, this.state.artistData)
                        var tags = [];
                        /* user tags logic */
                        if (this.state.artistData && this.state.artistData[0]) {
                            this.artistProfileTagsIdentifier(this.state.artistData[0])
                        }
                        else if (this.state.artistData && this.state.artistData) {
                            this.artistProfileTagsIdentifier(this.state.artistData)
                        }


                    })
                })

            this.props.followAndLikeStore.followingList(localStorage.getItem("profile_id"))
                .then((res) => {
                    // console.log(res);
                    this.setState({
                        followingList: res.data.data,
                        followingCount: res.data.count,
                        loadingFollowList: false

                    })
                })
            this.props.followAndLikeStore.followersList(localStorage.getItem("profile_id"))
                .then((res) => {
                    // console.log(res);
                    this.setState({
                        followersList: res.data.data,
                        followersCount: res.data.count
                    })
                })
        }
    }
    componentWillMount() {
        // console.log('identifier did monnt landingpage componentWillMount')
        if (localStorage.hasOwnProperty("userData")
        ) {

            this.props.userStore.pulluser().then((result) => {
                // console.log("{this is pulled user}", result)
                result.data[0]

                // if (!result.data[0].interests) {
                //     // console.log("interests null")
                //     this.setState({
                //         onboardingOneIncomplete: true
                //     })
                // }
                // if (!result.data[0].preferences) {
                //     // console.log("preferences null")
                //     this.setState({
                //         onboardingTwoIncomplete: true
                //     })
                // }

                if (!result.data[0].display_name && !!result.data[0].old_display_name) {
                    if ((result.data[0].old_display_name) && !validateInputLength(result.data[0].old_display_name, 6, 30)) {
                        // this.props.navigatorStore.openErrorModal("username should contain 6-30 characters");
                        this.setState({
                            onboardingThreeIncomplete: true
                        })
                        return;
                    }
                    if ((result.data[0].old_display_name) && !validateIfInputHasSpaces(result.data[0].old_display_name, 6, 30)) {
                        // this.props.navigatorStore.openErrorModal("username can not contain spaces")
                        this.setState({
                            onboardingThreeIncomplete: true
                        })
                        return;
                    }
                    if ((result.data[0].old_display_name) && validateIfInputHasCharacters(result.data[0].old_display_name)) {
                        // this.props.navigatorStore.openErrorModal("username can not contain characters");
                        this.setState({
                            onboardingThreeIncomplete: true
                        })
                        return;
                    }
                    if ((result.data[0].old_display_name) && validateIfInputHasUpperCaseLetter(result.data[0].old_display_name)) {
                        // this.props.navigatorStore.openErrorModal("username can not contain an uppercase letter")
                        this.setState({
                            onboardingThreeIncomplete: true
                        })
                        return;
                    }
                    if ((result.data[0].old_display_name) && validateIfInputHasYourMasterpieces(result.data[0].old_display_name)) {
                        // this.props.navigatorStore.openErrorModal("username can not contain yourmasterpieces in it")
                        this.setState({
                            onboardingThreeIncomplete: true
                        })
                        return;
                    }
                    var formData = new FormData();
                    formData.append("display_name", this.state.formInputs.display_name)
                    if (!!this.state.formInputs.display_name && (this.state.curr_display_name != this.state.formInputs.display_name))
                        this.props.userStore.validateDisplayName(formData)
                            .then((response) => {
                                // console.log(response)
                                if (response.error == "True") {
                                    this.setState({
                                        onboardingThreeIncomplete: true,
                                        // formInputs: { ...this.state.formInputs, display_name: "" }
                                    })
                                    // this.props.navigatorStore.openErrorModal(response.data)
                                    return;
                                }
                                else {
                                    this.setState({
                                        onboardingThreeIncomplete: true
                                    })
                                }
                            })
                            .catch((err => {
                                this.setState({
                                    onboardingThreeIncomplete: true,



                                })
                            }));
                }
                if (!result.data[0].full_name ||
                    !result.data[0].country ||
                    //  !response.data.user_profile[0].full_name || 
                    //  !response.data.user_profile[0].user.email || 
                    //  !response.data.user_profile[0].display_name || 
                    !result.data[0].display_name ||
                    result.data[0].display_name.length >= 30 ||
                    !result.data[0].primary_email ||
                    !result.data[0].preferred_currency

                ) {
                    // console.log("profile null")
                    this.setState({
                        onboardingThreeIncomplete: true
                    })
                    // this.state.makeOnboardingThreeIncomplete()
                }

            })
        }
    }

    toggleBuyingTab() {
        this.setState({
            buyingTab: "visible",
            sellingTab: "hidden"

        })
        // console.log("buying", this.state.buyingTab)
        // console.log("selling", this.state.sellingTab)
    }
    toggleSellingTab() {
        this.setState({
            buyingTab: "hidden",
            sellingTab: "visible"

        })
        // console.log("buying", this.state.buyingTab)
        // console.log("selling", this.state.sellingTab)
    }
    handelFollowersListClick() {
        // console.log("open follwoers modal");
        if (!localStorage.hasOwnProperty("userData")) {
            this.props.navigatorStore.openSignInModal();
            return;
        }
        this.setState({
            viewFollowersList: !this.state.viewFollowersList,
        }, () => {
            () => overFlowHidden()

            /*    this.props.followAndLikeStore.followersList(localStorage.getItem("profile_id"))
                   .then((res) => {
                       // console.log(res);
                       this.setState({
                           followersList: res.data.data,
                           followersCount: res.data.count
                       }, () => overFlowHidden())
                   }) */
        })




    }
    handleArtworkClick() {
        this.setState({
            artworkClicked: !this.state.artworkClicked
        })
    }
    handelFollowingListClick() {
        // console.log("open follwing modal")
        if (!localStorage.hasOwnProperty("userData")) {
            this.props.navigatorStore.openSignInModal();
            return;
        }
        this.setState({
            viewFollowingList: !this.state.viewFollowingList,
            loadingFollowList: true
        }, () => {
            overFlowHidden()
            /*   this.props.followAndLikeStore.followingList(localStorage.getItem("profile_id"))
                  .then((res) => {
                      // console.log(res);
                      this.setState({
                          followingList: res.data.data,
                          followingCount: res.data.count,
                          loadingFollowList: false
  
                      }, overFlowHidden())
                  }) */
        })




    }
    handelFollowRequest() {
        // console.log("followed you");
        this.setState({
            followedThisArtist: !this.state.followedThisArtist
        })
    }

    onCloseFollowers() {
        this.setState({
            viewFollowersList: false,

        }, () => {
            removeOverFlowHidden();
            this.loadArtistData(localStorage.getItem("username"), true, true)
        })



        // this.componentDidMount()
    }
    onCloseFollowing() {
        this.setState({
            viewFollowingList: false,
            // followingList: res.data.data,
            // followingCount : res.data.count
        }, () => {
            this.loadArtistData(localStorage.getItem("username"), true, true)
            removeOverFlowHidden();
        })

        // this.componentDidMount()
    }
    handleReadInstructionsCheck() {
        // console.log("checked")
        this.setState({
            readInstructions: !this.state.readInstructions
        })
    }
    close = () => this.setState({ uploadArt: false });

    handelUploadArtBtnClick() {

        // console.log("set upload art true")
        this.setState({
            uploadArt: !this.state.uploadArt
        })
    }
    handleSeeMore() {
        this.setState({
            seeMore: !this.state.seeMore
        })
    }
    handelContinueClick() {

        if (!this.state.readInstructions) {
            this.props.navigatorStore.openErrorModal("Please accept the terms to upload your artwork");
            return;
        }
        this.setState({
            wantsToContinue: !this.state.wantsToContinue
        })
    }



    getImageNameReadInstructions = () => this.state.readInstructions ? 'checked' : 'unchecked'
    render() {
        const imageNameInstructions = this.getImageNameReadInstructions();
        if (this.state.toProfile) {
            return (
                <Redirect push to="/edit-profile"></Redirect>
            )
        }
        // console.log("look here", this.state.artistData)
        if (this.state.wantsToContinue && this.state.readInstructions) {
            return (
                <Redirect push to="/uploadimage2"></Redirect>
            )
        }
        else if (this.state.wantsToContinue) {
            // this.props.navigatorStore.openErrorModal("Please read all the instructions first");
            this.setState({
                wantsToContinue: false
            })
        }
        if (this.props.authStore.RegisterSuccess) {
            this.props.authStore.resetRegisterSuccess("onboardingOneIncomplete")
            this.props.authStore.resetRegisterSuccess("onboardingTwoIncomplete")
            this.props.authStore.resetRegisterSuccess("onboardingThreeIncomplete")
            return (
                <Redirect push to='/onboardingone' />
            )
        }

        if (window.localStorage.hasOwnProperty("userData") && this.state.onboardingOneIncomplete) {
            // console.log("redirecting to onboardingOne");
            return (
                <Redirect push to="/onboardingone"></Redirect>
            )
        }
        if (window.localStorage.hasOwnProperty("userData") && this.state.onboardingTwoIncomplete) {
            // console.log("redirecting to onboardingTwo");
            return (
                <Redirect push to="/onboardingtwo"></Redirect>
            )
        }
        // setTimeout(
        //     ()=>{

        if (
            (window.localStorage.hasOwnProperty("userData") && this.state.onboardingThreeIncomplete)
        ) {
            // console.log("identifier redirecting to onboardingThree ", this.props.authStore.updateComplete, this.props.authStore.onboardingThreeIncomplete);

            this.props.authStore.resetUpdateComplete()
            return (
                <Redirect push to="/onboardingthree"></Redirect>
            )
        }


        return (


            <div className="main-container-artist-detail-page">
                <div className="artist-detail-background">
                    <img style={{ maxHeight: "260px" }} src={require('../../assets/artist_banner.png')} />


                    <div className="title-artist-page">
                    </div>
                </div>


                <Modal show={this.state.uploadArt} onClose={this.close} {...this.props.modal} className="crop-screen-modal" >
                    {this.props.children}
                    <Modal.Content className="uploadTermsModal">
                        <div className="masterpieces-modal-header pt-20 pb-25 ml-25">
                            <p className="masterpieces-modal-heading">Upload Artwork
                                        <img onClick={this.close}
                                    className="cross-icon-for-masterpieces-modal"
                                    src={require('../../assets/cross_icon_for_close.png')}></img>
                            </p>
                        </div>
                        <div className="masterpieces-modal-content">
                            <div className="terms-and-conds-content ">

                                <div className="important-instructions mb-25">
                                    <img alt="" className="terms-and-conds-upload-icon" src={goldenHandIcon}></img>
                                    <div className="terms-and-conds-important-instructions">
                                        <h className="terms-and-conds-important-instructions-heading"> Seller
                                            terms of use
                                                 </h>
                                        <p className=" terms-and-conds-important-instructions-content">Please
                                            make sure you read and agree with the terms of using the
                                                     yourmasterpieces platform for selling or showcasing art.</p>
                                    </div>
                                </div>

                                <p className="terms-text">
                                    Please read carefully the following terms and conditions as they govern your
                                    access to and use of the site and services, and constitute a binding legal
                                    agreement between you and Masterpieces.
                                        </p>
                                <p className="terms-text">
                                    You acknowledge and agree that, by accessing or using, or by selling, or by
                                    posting any content on this platform, you are indicating that you have read,
                                    understood and agreed to be bound by the following terms.
                                        </p>
                                <ol className="terms-list terms-text">
                                    <li className="mb-15">Use of Artwork</li>
                                    <li className="mb-15">No Commission Model</li>
                                    <li className="mb-15"> Pricing</li>
                                    <li className="mb-15"> Packing the Artwork</li>
                                    <li className="mb-15"> Do Not Solicit Buyers Directly</li>
                                    <li className="mb-15"> Quality Check</li>
                                </ol>

                                <p className="terms-text">

                                    <b>1. Use of Artwork: </b>
                                    By accepting the terms of use of the YourMasterpieces platforms (app, website,
                                    etc.) you are allowing YourMasterpieces to use the image(s) of your artwork for
                                    promotions across the platform(s) and forums it deems fit. We will never sell
                                    these images to any third party or allow them to use it for any other purpose.
                                        </p>
                                <p className="terms-text">
                                    <b>2. No Commission Model: </b> The price you quote is the price you get.
                                    YourMasterpieces does not charge you any commission for the selling of the
                                    artwork on its platform(s).
                                    </p>

                                <p className="terms-text"><b>3. Pricing: </b>YourMasterpieces will add a small
                                    convenience fee; presently this is between 5-15% of the quoted price, to cover
                                    expenses. The price displayed on the platform(s) will be inclusive of this fee.
                                    The packing, shipping and handling charges will be calculated based on the
                                    distance between the buyer and the seller and the mode of shipment, and will be
                                    intimated to the seller at actuals after the buy request is received.
                                        </p>

                                <p className="terms-text"><b>4. Packing the Artwork:</b>

                                    While YourMasterpieces takes the responsibility of shipping an artwork the
                                    responsibility for correct packaging of the artwork lies with the artist. We
                                    request all artists to professionally pack their artwork to ensure its safety
                                    during transit. Ensure artworks are completely dry before packing them and
                                    protect the artwork with a layer of glassine paper on the painted surface. Use
                                    the correct type of packing paper like glassine/ butter paper as the first layer
                                    between the artwork and any packing material like bubble wrap or newspaper. Do
                                    not use printed paper, newspaper, or anything printed with ink to create the
                                    first layer of packing. Research the correct form of packaging for your artwork
                                    to prevent any damage during transit.
                                    </p>

                                <p className="terms-text"><b>
                                    5. Do Not Solicit Buyers Directly:</b>


                                    We strongly advise artists to never directly connect with buyers on the
                                    YourMasterpieces platform to avoid any instances of fraud. We suggest this
                                    because in the event of a sale through the YourMasterpieces website, we
                                    guarantee payment to the artist within 10 business days. But, YourMasterpieces
                                    does not take any responsibility for direct dealings between artists and buyers
                                    and will not entertain any complaints regarding the same.
                                    </p>

                                <p className="terms-text pb-15"><b>6. Quality Check:</b>

                                    The photograph of your artwork is the only reference the buyer has of your art.
                                    Make sure the image you upload on our platform captures the essence and beauty
                                    of your artwork. When photographing your artwork for YourMasterpieces profile
                                    make sure to shoot in bright soft light keeping a minimal distance from the
                                    artwork and ensure that your flash is turned off. We advise you to upload high
                                    resolution images to ensure a good visual experience. For framed artworks, the
                                    frames can be a part of the image if they are integral to the essence of your
                                    artwork but make sure you crop all edges from the image and do not include any
                                    mounts on an artwork. Also, please do not upload paintings/ink/pencil
                                    scribbles/sketches in notebooks or A4 size papers. This needs to be adhered to,
                                    to maintain a certain level of uniformity in the kind of artworks that go up on
                                    the platform(s). Remember, your image needs to conform to these specifications
                                    to be accepted on the website and can be removed from the platform if it doesn’t
                                    meet our quality standards.

                                    </p>

                            </div>
                            <div className="masterpieces-modal-footer mt-15 pt-15 pb-15 height56">
                                <div style={{ marginLeft: "5%", display: "flex", flex: 1, marginTop: "5%" }}>
                                    <img alt="" src={imagesPath[imageNameInstructions]} onClick={this.handleReadInstructionsCheck.bind(this)} className="agreement-checkbox">

                                    </img>
                                    <div className="agreement-text">
                                        I agree with YourMasterpieces <a className="agree-link" href="/terms-and-conditions"  style={{color : "#BEA57C"}}>terms of use</a> 
                                            </div>
                                </div>
                                <Button onClick={this.handelContinueClick.bind(this)} className="masterpieces-primary-buttons btn-primary" id="continue-button">
                                    CONTINUE
                                         </Button>
                            </div>
                        </div>
                    </Modal.Content>
                </Modal>
                {/*<FollowBtn myOwnProfile={this.state.myOwnProfile} handelUploadArtBtnClick={this.handelUploadArtBtnClick.bind(this)} followedThisArtist={this.state.followedThisArtist} handelFollowRequest={this.handelFollowRequest.bind(this)} />*/}


                <ArtistBasicInfo
                    viewPortWidth={this.state.viewPortWidth}
                    handleSeeMore={this.handleSeeMore.bind(this)}
                    seeMore={this.state.seeMore}
                    handleViewProfile={this.handleViewProfile.bind(this)}
                    share_url={(this.state.artistData) ? (this.state.artistData.length) ? this.state.artistData[0].user_profile.share_url : this.state.artistData.user_profile.share_url : ""}
                    artistInfo={this.state.artistData}
                    handelUploadArtBtnClick={this.handelUploadArtBtnClick.bind(this)}
                    followersCount={this.state.followersCount}
                    followingCount={this.state.followingCount}
                    artist_profile_tags={this.state.artist_profile_tags}
                    handelFollowersListClick={this.handelFollowersListClick.bind(this)} handelFollowingListClick={this.handelFollowingListClick.bind(this)} />
                <TabsForArtistDetails
                    artistUn={localStorage.getItem("username")}
                    artistId={this.state.artistId}
                    followers={this.state.following}
                    artworkCount={this.state.artworkCount}
                    toggleBuyingTab={this.toggleBuyingTab.bind(this)}
                    toggleSellingTab={this.toggleSellingTab.bind(this)}
                    collection={this.state.collection}
                    collectionCount={this.state.collectionCount}
                    ArtworkData={this.state.artistData} />
                <Modal show={this.state.viewFollowersList} onClose={this.onCloseFollowers.bind(this)} >
                    <Modal.Content>

                        <div className="masterpieces-modal-header pt-20 pb-25 ml-25">
                            <p className="masterpieces-modal-heading">{(this.state.followersCount)} Followers
                            <img onClick={this.onCloseFollowers.bind(this)} className="cross-icon-for-masterpieces-modal" src={require('../../assets/cross_icon_for_close.png')}></img></p>
                        </div>
                        <div className="followers-list-modal-content pt5" id={this.state.uniqueContainerIdFollowers}>
                            <FollowersList close={this.onCloseFollowers.bind(this)} artistFollowersList={this.state.followersList} id={this.state.artistId} />

                        </div>
                    </Modal.Content>
                </Modal>
                <Modal show={this.state.viewFollowingList}
                    loading={this.state.loadingFollowList}
                    onClose={this.onCloseFollowing.bind(this)} >
                    <Modal.Content>

                        <div className="masterpieces-modal-header pt-20 pb-25 ml-25">
                            <p className="masterpieces-modal-heading">{(this.state.following)} Following
                            <img onClick={this.onCloseFollowing.bind(this)} className="cross-icon-for-masterpieces-modal" src={require('../../assets/cross_icon_for_close.png')}></img></p>
                        </div>
                        <div className="followers-list-modal-content pt5" id={this.state.uniqueContainerIdFollowing}>
                            <FollowersList
                                loading={this.state.loadingFollowList}

                                close={this.onCloseFollowing.bind(this)} artistFollowersList={this.state.followingList} id={this.state.artistId} following={true} />
                        </div>
                    </Modal.Content>
                </Modal>

            </div>


        )
    }
}


const FollowBtn = (props) => {

    return (
        <div style={{ position: "relative" }}>
            <img style={{ display: (props.myOwnProfile) ? "" : "none" }} alt="" className="upload-art-icon" onClick={props.handelUploadArtBtnClick} src={uploadArtIcon} />
            <p className="follow-text-artist-page" style={{ display: (props.myOwnProfile) ? "none" : "", opacity: "1" }}>{(props.followedThisArtist) ? "UNFOLLOW" : "FOLLOW"}</p>
            <Button style={{ display: (props.myOwnProfile) ? "none" : "" }} className="follow-btn-artist-page" onClick={props.handelFollowRequest}>
            </Button>
        </div>
    )
}

const ArtistIdFromUrl = (string) => {
    return (
        string.split("-").pop()
    )
}

const ArtistBasicInfo = (props) => {
    let { artistInfo } = props;
    // console.log("lool look look", artistInfo);
    return (
        (artistInfo && ((artistInfo.length) ? artistInfo[0].user_profile : artistInfo.user_profile)) ?
            //    artistInfo.map((el, elIndex) =>


            <div className="artist-details-slider">
                <div className="container">
                    <div className="col-md-12">
                        <div className="row">

                            <div className="col-12 col-sm-12 col-md-12 col-lg-3 text-center">
                                <div className="no-border mb-25">
                                    <img alt=""
                                        src={((artistInfo.length) ? artistInfo[0].user_profile.image :
                                            artistInfo.user_profile.image) ||
                                            require('../../assets/default_square_picture.png')}
                                        className="artistProfileImg" />
                                </div>
                            </div>

                            <div className="col-12 col-sm-12 col-md-12 col-lg-9">

                                <div className="row pt-15 mb-15">
                                    <div
                                        className="col-12 col-md-12 col-lg-8 d-flex justify-content-center justify-content-lg-start">
                                        <div className="artis-name-block">
                                            <h1 className="artist-name-heading">

                                                {
                                                    (artistInfo.length) ?
                                                        artistInfo[0].user_profile.full_name : artistInfo.user_profile.full_name

                                                }


                                            </h1>
                                        </div>
                                    </div>

                                    <div className="col-12 col-sm-12 col-md-12 col-lg-4 d-flex justify-content-center justify-content-lg-end button-artist-details">
                                        <div className="d-flex justify-content-center justify-content-md-center justify-content-lg-end">
                                            {/* <a href="/edit-profile"> */}
                                            <button onClick={props.handleViewProfile}

                                                type="button"
                                                className="btn follow-btn-new mr-15 height-36 bg-grey-button">
                                                EDIT PROFILE
                                            </button>
                                            {/* </a> */}

                                            <UncontrolledDropdown nav inNavbar>
                                                <DropdownToggle nav caret style={{ padding: "none" }}>

                                                    <button type="button" style={{ color: "black", background: "white" }}
                                                        className="btn share-btn-new share-profile artist-share mr-15 height-36 bg-grey-button">SHARE
                                                    </button>
                                                </DropdownToggle>
                                                <ShareMenu share_url={props.share_url} />
                                            </UncontrolledDropdown>
                                        </div>
                                    </div>
                                </div>

                                <div className="row">

                                    {/* <div className="col-md-12 d-flex justify-content-center justify-content-sm-center justify-content-md-center justify-content-lg-start">
                                        <h5 className="attheratetext">
                                            @{
                                                (artistInfo.length)
                                                    ? (artistInfo[0].user_profile.display_name) ? artistInfo[0].user_profile.display_name : artistInfo[0].user_profile.old_display_name :
                                                    (artistInfo.user_profile.display_name) ? artistInfo.user_profile.display_name : artistInfo.user_profile.old_display_name

                                            }
                                        </h5> */}
                                    <div className="col-md-12">
                                        <div className="row">
                                            <div className="col-md-12 col-lg-8 d-flex justify-content-center justify-content-lg-start">
                                                <h5 className="attheratetext">
                                                    @{
                                                        (artistInfo.length)
                                                            ? (artistInfo[0].user_profile.display_name) ? artistInfo[0].user_profile.display_name : artistInfo[0].user_profile.old_display_name :
                                                            (artistInfo.user_profile.display_name) ? artistInfo.user_profile.display_name : artistInfo.user_profile.old_display_name

                                                    }
                                                </h5>
                                            </div>

                                            <div className="col-md-12 col-lg-4 d-flex justify-content-center justify-content-lg-end">
                                                <button type="button"
                                                    className="btn  mr-15 artwork-upload-btn" onClick={props.handelUploadArtBtnClick}>
                                                    <img alt="icon-art" src={require('../../assets/upload_art.png')} className="art-icon-image" />                                                   UPLOAD ARTWORK
                                                </button>
                                            </div>

                                        </div>
                                    </div>

                                    <div className="col-md-12 d-flex justify-content-center justify-content-sm-center justify-content-md-center justify-content-lg-start">
                                        {
                                            props.artist_profile_tags.map((el) =>
                                                <span className="explorer-design mr-2">
                                                    {el}
                                                </span>
                                            )
                                        }

                                    </div>

                                    <div className="col-md-12">

                                        <div className="row">
                                            <div className="col-md-12 col-lg-5 d-flex justify-content-center justify-content-sm-center justify-content-md-center justify-content-lg-start">
                                                <div className="location">
                                                    <img src={require('../../assets/location.png')} alt="location"
                                                        className="location-img" />
                                                    {(artistInfo.length) ? (artistInfo[0].user_profile && !!artistInfo[0].user_profile.city) ? `${artistInfo[0].user_profile.city}, ` : (artistInfo.user_profile && !!artistInfo.user_profile.city) ? `${artistInfo.user_profile.city}, ` : "" : ""}
                                                    {(artistInfo.length) ? artistInfo[0].user_profile.country || "Unavailable" : artistInfo.user_profile.country || "Unavailable"}
                                                </div>
                                            </div>

                                            <div className="col-md-12 col-lg-7 d-flex justify-content-center justify-content-sm-center justify-content-md-center justify-content-lg-end">
                                                <div className="d-flex justify-content-end">
                                                    <Button className="artist-like pull-right"><b
                                                        className="pr-8">{(artistInfo.length) ? artistInfo[0].user_profile.total_likes_received || 0 : artistInfo.user_profile.total_likes_received || 0}</b>
                                                        Likes </Button>
                                                    <Button className="artist-like pull-right"
                                                        onClick={props.handelFollowersListClick}><b
                                                            className="pr-8">{(artistInfo.length) ? artistInfo[0].user_profile.followers || 0 : artistInfo.user_profile.followers || 0}</b>Followers
                                                    </Button>
                                                    <Button className="artist-like pull-right"
                                                        onClick={props.handelFollowingListClick}><b
                                                            className="pr-8">{(artistInfo.length) ? artistInfo[0].user_profile.following || 0 : artistInfo.user_profile.following || 0}</b>
                                                        Following </Button>
                                                </div>
                                            </div>
                                        </div>

                                        <div className="col-md-12">
                                            <div className="row">
                                                <div className="bio-section d-flex justify-content-center justify-content-lg-left">
                                                    <h5 className={(props.seeMore) ? "bio-artist-full" : "bio-artist"}
                                                        style={{ '-webkit-box-orient': 'vertical' }}>
                                                        {(artistInfo.length) ? artistInfo[0].user_profile.bio : artistInfo.user_profile.bio}

                                                    </h5>
                                                </div>
                                                {/* {props.viewPortWidth} */}
                                                <p onClick={props.handleSeeMore}
                                                    style={{
                                                        display: (artistInfo.length) ? artistInfo[0].user_profile.bio.length > props.viewPortWidth ?
                                                            "" : "none" :
                                                            artistInfo.user_profile.bio.length > props.viewPortWidth

                                                                ? "" : "none"
                                                    }}
                                                    className="agree-link bio-see-more-btn">Read {(props.seeMore) ? ` less` : ` more`} </p>
                                            </div>
                                        </div>

                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>

            : <div></div>
    )

}

@inject('userStore', 'navigatorStore', 'authStore', 'commonStore', 'landingPageArtworksStore', 'artworksStore', 'artistDetails', 'followAndLikeStore')
@observer
class TabsForArtistDetails extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            uniqueContainerId: "container_" + new Date().getTime() + Math.random(),
            uniqueContainerId1: "container1_" + new Date().getTime() + Math.random(),
            reachedPageEnd: false,
            activeTab: 1
        }
    }

    componentDidMount() {
        document.addEventListener('scroll', this.trackScrolling);
        this.loadUserArtworks();
    }
    isBottom(el) {
        return el.getBoundingClientRect().bottom <= window.innerHeight;
    }
    loadFunc() {
        this.props.artworksStore.loadmoreCollectionMyProfile();

        this.loadCollection()
    }
    componentWillUnmount() {
        this.props.artworksStore.resetCollectionMyProfile()
        this.props.artistDetails.reset()

    }
    trackScrolling = () => {
        var wrappedElement
        if (this.state.activeTab == 2) {
            wrappedElement = document.getElementById(this.state.uniqueContainerId);

        } else {
            wrappedElement = document.getElementById(this.state.uniqueContainerId1)
        }
        if (!wrappedElement) return
        let reachedPageEndNow = this.isBottom(wrappedElement);
        // // console.log('[trackScroll] ', { reachedPageEndNow, reachedPageEnd: this.state.reachedPageEnd });
        if (this.isBottom(wrappedElement)) {
            // // console.log('[trackScroll] FAKE ');
        };
        if ((reachedPageEndNow && !this.state.reachedPageEnd) || (!reachedPageEndNow && this.state.reachedPageEnd)) {
            this.setState({ reachedPageEnd: reachedPageEndNow })
            // reachedPageEndNow &&  console.log('[trackScroll] REAL ');
            if (reachedPageEndNow) {
                if (this.state.activeTab == 2) {
                    this.loadFunc()
                } else {
                    if (!!localStorage.hasOwnProperty("username")) { this.loadMoreUserArtworks(); }
                }
            }
        }

    };
    loadMoreUserArtworks() {
        if (!!localStorage.hasOwnProperty("username")) {
            if (localStorage.hasOwnProperty("userData")) {
                this.props.artistDetails.loadMore("private")
            } else {
                this.props.artistDetails.loadMore("public")

            }
            this.loadUserArtworks()
        }
    }
    loadUserArtworks() {
        // console.log("I am comming here tool with", localStorage.getItem("username"));
        // if (!localStorage.hasOwnProperty("userData")) {
        if (!!localStorage.getItem("username")) {
            this.props.artistDetails[localStorage.hasOwnProperty("userData") ? "getArtistDetailsPrivate" : "getArtistDetailsPublic"](localStorage.getItem("username"), true)

                .then((resp) => {
                    console.log("this is artist data tool", resp, this.state.artworkData);
                    var joined = (
                        this.state.artworkData && this.props.artworkCount > 0 &&
                        this.props.artistDetails[
                        localStorage.hasOwnProperty("userData") ? "privateApiOffset" : "publicApiOffset"
                        ]) ? this.state.artworkData.concat(resp.data.data) : resp.data.data
                    // artistId: resp.data.data[0].id;
                    this.setState({
                        artworkCount: resp.data.count,
                        artworkData: joined,

                    }, function () {
                        // console.log("this is artist data tool", this.state.artistData)
                        // var tags = [];
                        /* user tags logic */
                        // this.loadOtherData(this.state.artistId, hide)
                    }
                    )
                })
        }

    }
    loadCollection() {

        // console.log("comming here to load collection ")
        this.props.artistId && this.props.artworksStore.getArtworkCollectionProfile(this.props.artistId, true)
            .then((resp) => {
                // console.log("this is collection data", resp);
                var joined = (this.state.collection && this.props.collectionCount > 0) ? this.state.collection.concat(resp.data.data) : resp.data.data
                this.setState({
                    // collectionCount: resp.data.count,
                    collection: joined,
                    collectionCount: resp.data.count
                    // followedThisArtist: (resp.data.data.length) ? resp.data.data[0].user_profile.isfollowing : resp.data.data.user_profile.isfollowing,
                    // artistId: str.replace(/\D/g, "")
                }, function () {
                    // console.log(resp)
                })
            });
    }

    toggleTabs(tabId) {
        // console.log("toggeling", tabId)
        if (!this.state.collectionRendered && tabId == 2) this.loadCollection()
        this.setState({
            activeTab: tabId,
            collectionRendered: true,
        }, () => {
            // console.log("something", this.props.artistId)
        })
    }
    render() {


        let props = this.props
        // return <Tabs onSelect={(index, label) => // console.log(`Selected Index: ${index}, Label: ${label}`)} selected="tab 2">
        //     <Tab label="tab 1">This is Tab 1</Tab>
        //     <Tab label="tab 2">This is Tab 2</Tab>
        //     <Tab label="Disabled" disabled></Tab>
        // </Tabs>
        return (
            <div className="tabs artist-tabs" style={{ marginLeft: "30%", margin: "0px auto", minWidth: "100%", justifyContent: "center", flex: 1 }}>
                {/* 25 Artworks */}

                <div className="tab-button-buying"   >
                    <div className="tab-button-buying" id="profile-details-tab"  >
                        <div className={(this.state.activeTab == 1) ? "profile-details-tab-display-active" : "profile-details-tab-display-inactive"} style={{ flex: 1 }}
                            onClick={() => this.toggleTabs(1)}>{`ARTWORKS ${(props.ArtworkData) ? props.artworkCount || 0 : 0}`}</div>
                        <div className={(this.state.activeTab == 2) ? "profile-details-tab-display-active" : "profile-details-tab-display-inactive"} style={{ flex: 1 }}
                            onClick={(localStorage.hasOwnProperty("userData")) ? () => this.toggleTabs(2) : ""}>{`COLLECTION ${props.collectionCount || 0} `}</div>
                    </div>
                    <div id={this.state.uniqueContainerId1} style={{ display: (this.state.activeTab == 1) ? "" : "none" }}>
                        {(!props.artworkCount) ?

                            <div className="bg-grey-empty">
                                <div className="d-flex justify-content-center">
                                    <div className="rectangle-block">
                                        <div className="rectangle-out">
                                            <div className="rectangle-in">
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                <div className="d-flex justify-content-center">
                                    <div className="container">
                                        <p className="empty-canvas-text"> Your canvas is currently blank.<br />

                                        </p>
                                    </div>
                                </div>
                            </div>
                            :
                            <Artworks ArtworkData={this.state.artworkData} />
                        }
                    </div>
                    {/* {props.letsSee} */}
                    <div style={{ display: (this.state.activeTab == 2) ? "" : "none" }}

                        id={this.state.uniqueContainerId} >
                        {/* Rendered here {this.state.uniqueContainerId} */}
                        <div style={{ height: "360px", display: (!props.collectionCount) ? "" : "none", backgroundColor: "#F6F6F6" }}>

                            <p className="empty-canvas-text"> You have not added any artwork to your collection yet.<br />

                            </p>
                        </div>
                        <ArtworksCollectionCard artworkData={this.state.collection} />
                    </div>

                </div>
            </div>
        )
    }

}

const Artworks = (props) => {
    return (
        <div className="artist-artwork-block artwork-detail-block height-initial">
            <section className="artworks-detail-section x-close pb-25" ref={this.myref}>
                <div className="col-md-12">
                    <div className="row">
                        <div className="tabs-container" style={{ marginTop: "3%" }}>
                            <div className="col-md-12">
                                <div className="" >
                                    <ArtworkCard artworkData={props.ArtworkData} />
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </section>
        </div>
    )
}
const ArtworksCollectionCard = (props) => {
    return (
        <div className="artist-artwork-block artwork-detail-block height-initial"
            style={{ minHeight: localStorage.hasOwnProperty("userdata") ? "-webkit-fill-available" : "" }}>
            <section className="artworks-detail-section x-close pb-25" ref={this.myref}>
                <div className="col-md-12">
                    <div className="row">
                        <div className="tabs-container" style={{ marginTop: "3%" }}>
                            <div className="col-md-12">
                                <div className="" >
                                    <ArtworkCard_ artworkData={props.artworkData} />
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </section>
        </div>
    )
}











// WEBPACK FOOTER //
// ./src/components/artist/myProfile.js